var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('custom-select',{attrs:{"label":_vm.label,"value":_vm.value,"name":_vm.name,"items":_vm.companias,"validation-error":_vm.error,"valueDisabled":"Seleccioná la empresa"},on:{"input":_vm.onChange,"click":function($event){return _vm.$emit('click')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }